import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getNutraceutica = gql`
  ${seoFragment}
  query GetNutraceutica($site: [String]) {
    nutraceuticaPageEntries(site: $site) {
      ... on nutraceuticaPage_Entry {
        id
        seo {
          ...SeoFragment
        }
        generalHeader {
          ... on generalHeader_Entry {
            id
            generalHeaderTitle
            generalHeaderText
            sezioneImmagineVideoFull {
              ... on sezioneImmagineVideoFull_Entry {
                imageVideoTitle
                imageVideoText
                fullVideoUrlPreview
                fullVideoUrl
                fullVideoButtonText
                fullImage {
                  id
                  title
                }
                landscape: fullImage
                  @transform(format: "webp", width: 3840, height: 2160) {
                  id
                  url
                  width
                  srcset(sizes: ["750w", "1300w", "1920w"])
                  height
                  title
                }
                mobile: fullImageMobile
                  @transform(format: "webp", width: 1000, height: 1500) {
                  id
                  url
                  width
                  srcset(sizes: ["750w", "1000w"])
                  height
                  title
                }
              }
            }
          }
        }
        sezioneTitoloTestoPagina {
          ... on sezioneTitoloTestoPagina_Entry {
            id
            sectionTitle
            text
          }
        }
        sezioneImmagineTesto {
          ... on sezioneImmagineTesto_Entry {
            id
            portrait: immagine
              @transform(format: "webp", width: 1500, height: 1780) {
              id
              url
              srcset(sizes: ["750w", "1000w"])
              width
              height
              title
            }
            coloreTitolo
            coloreSfondo
            sectionTitle
            text
            invertiOrdine
            linkDefault
            label
          }
        }
        carosello {
          ... on carosello_Entry {
            sectionTitle
            text
            slide {
              ... on slide_Entry {
                sectionTitle
                coloreTitolo
                text
                linkDefault
                portrait: immagine @transform(width: 800, height: 800) {
                  id
                  url
                  srcset(sizes: ["750w", "1000w"])
                  width
                  height
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`
